import { bankCardsFromDto, coinPricesFromDto } from '@helpers/payments';
import { PaymentsGetSettingsRequestData, PaymentsGetSettingsRequestParams, PaymentsGetSettingsResponseData, PaymentsGetSettingsResponseDto } from '@services/dto/payments';
export const paymentsGetSettingsRequestToParams = (data: PaymentsGetSettingsRequestData): PaymentsGetSettingsRequestParams => {
  return {
    paymentMethodId: data.paymentMethodId,
    aggregatorId: data.aggregatorId,
    categories: data.categories
  };
};
export const paymentsGetSettingsResponseFromDto = (dto: PaymentsGetSettingsResponseDto): PaymentsGetSettingsResponseData => {
  return {
    ...dto.data,
    bankCards: bankCardsFromDto(dto.data.bankCards),
    coinPrices: coinPricesFromDto(dto.data.coinPrices)
  };
};